import React, { useState } from 'react';
import {
  SaveButton,
  Toolbar,
  DeleteButton,
  useRecordContext,
  useResourceContext,
} from 'react-admin';
import DeleteAlertDialog from '../../../components/DeleteAlertDialog/DeleteAlertDialog';
import RemoveButton from '../../../components/RemoveButton/RemoveButton';

const ToolBarEditProgram = ({ uploading, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const record = useRecordContext();
  const resource = useResourceContext();

  const deleteExercise = () => {
    setIsOpen(true);
  };

  const handleCloseModalDelete = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Toolbar
        {...props}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          background: 'none',
        }}
      >
        <SaveButton
          label={uploading ? 'Uploading video…' : 'save'}
          alwaysEnable={!uploading}
          disabled={uploading}
        />
        <RemoveButton variant="contained" deleteExercise={deleteExercise} />
      </Toolbar>
      <DeleteAlertDialog
        title="Delete Program"
        subtitle="Are you sure you want to delete program ?"
        description="Program will be deleted permanently and removed from all the programs where it appears."
        record={record}
        open={isOpen}
        handleClose={handleCloseModalDelete}
      >
        <DeleteButton redirect="/programs" record={record} resource={resource} />
      </DeleteAlertDialog>
    </>
  );
};

export default ToolBarEditProgram;
